import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class StatusTable02 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "ledColumn", title: "Status LED" },
        { name: "blueColumn", title: "Blue LED" },
        { name: "redColumn", title: "Red LED" }
      ],
      rows: [
        { ledColumn: 'flashes every 2s', blueColumn: 'network connection LAN', redColumn: 'defect / boot loop' },
        { ledColumn: 'flashes 3x per seconds', blueColumn: 'network connection WiFi', redColumn: 'N/A' },
        { ledColumn: 'continuously on', blueColumn: 'booting or WPS function', redColumn: 'normal operation' },
        { ledColumn: 'continuously off', blueColumn: 'no power', redColumn: 'no power or no LED (newer models)' }
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

StatusTable02.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(StatusTable02)